export default __webpack_public_path__ + "static/HKGrotesk-Bold-4b8abf359f1a287be96081b985a98be0.woff";